export const DEFAULT_RESPONSES = [
  {
    title: 'I’ll join ✅',
    color: '#06C706',
    isCommentRequired: false,
  },
  {
    title: 'I won’t attend ❌',
    color: '#F06262',
    isCommentRequired: false,
  },
  {
    title: 'Not sure yet 🟨',
    color: '#FFAF63',
    isCommentRequired: false,
  },
  // {
  //   title: 'Neutral',
  //   color: '#6C757D',
  //   isCommentRequired: false,
  // },
];
